module.exports = __webpack_public_path__ + "img/weixin.1231658a.png";